__turbopack_context__.v({
  "button-highlight": "HomeContentToggle-module__KEfbxa__button-highlight",
  "groupedOptions": "HomeContentToggle-module__KEfbxa__groupedOptions",
  "moreButton": "HomeContentToggle-module__KEfbxa__moreButton",
  "tabHighlight": "HomeContentToggle-module__KEfbxa__tabHighlight",
  "tabRainbow": "HomeContentToggle-module__KEfbxa__tabRainbow",
});
